import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vfs-dec-data-import-steps',
  templateUrl: './dec-data-import-steps.component.html',
  styleUrls: ['./dec-data-import-steps.component.scss']
})
export class DecDataImportStepsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
